import request from '@/utils/seftRequest';

export function checkVirtualToFixed(params) {
  return request('/ding/subsService/changeMainProdCheckBsnl', {
    method: 'POST',
    body: params,
  });
}

export function changeMainProdBsnl(params) {
  return request('/ding/subsService/changeMainProdBsnl', {
    method: 'POST',
    body: params,
  });
}
